'use strict';

var urlRegex = require('./main.js');

module.exports = urlRegex(RegExp);
